<app-details-wrapper
  [title]="selectedCategory().name"
  [headerIconName]="'label'"
  [headerIconWrapperClass]="
    'tw-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-xl tw-border tw-border-solid tw-border-color-border-subtle tw-bg-color-surface-page'
  "
  [backButtonClass]="'btn-icon-plain'"
  [isOverlay]="true"
  (onBackClicked)="handleBackClick()"
>
  <!-- My Linked Transactions -->
  <div class="tw-flex tw-flex-col tw-gap-3 tw-rounded-lg tw-pb-3">
    <div
      class="tw-rounded-2xl tw-border tw-border-color-border-subtle tw-bg-color-surface-card tw-shadow-elevation-card"
    >
      <app-widget [backgroundClass]="'tw-bg-color-surface-card'" [hideIcon]="true">
        <div class="tw-flex tw-items-center tw-justify-between">
          <div titleWidget class="tw-flex tw-items-baseline tw-gap-1 tw-min-w-0">
            <span
              class="tw-text-sm tw-font-semibold tw-uppercase tw-text-color-text-secondary tw-truncate"
            >
              {{ "myTransactions" | i18n }}
            </span>
            <span
              class="tw-text-color-text-action tw-text-base tw-flex-shrink-0 tw-whitespace-nowrap tw-font-semibold"
            >
              ({{ linkedTransactionCount() }})
            </span>
          </div>
          <div action class="tw-flex-shrink-0">
            <app-gloss-button
              [options]="{
                link: '/views',
                text: 'pastView' | i18n,
                isEnabled: true,
                onClick: this.goToPastView.bind(this),
                fullClass:
                  'tw-w-[139px] tw-h-[36px] tw-rounded-[8px] border-gradient-neuomorphic tw-bg-color-surface-hover tw-text-color-text-default tw-text-sm tw-font-medium tw-shadow-elevation-card !tw-shadow-accounts-detail-surface hover:!tw-shadow-accounts-detail-surface active:!tw-shadow-accounts-detail-surface',
              }"
            ></app-gloss-button>
          </div>
        </div>
      </app-widget>
    </div>

    <!-- Category Detail -->
    <div
      class="tw-rounded-2xl tw-border tw-border-color-border-subtle tw-bg-color-surface-card tw-shadow-elevation-card"
    >
      <app-widget [backgroundClass]="'tw-bg-color-surface-card'" [hideIcon]="true">
        <div class="tw-flex tw-flex-col tw-gap-3">
          <span class="tw-text-sm tw-font-semibold tw-uppercase tw-text-color-text-secondary">
            {{ "categoryDetails" | i18n }}
          </span>

          <!--category name-->
          <app-input
            [label]="'categoryName' | i18n"
            [value]="categoryNameValue()"
            [isRequired]="true"
            [isDisabled]="source() !== categorySource.manual"
            (outputValue)="onCategoryNameChange($event)"
          ></app-input>

          <!--source-->
          <div
            class="tw-flex tw-items-center tw-justify-between tw-border-0 tw-border-t tw-border-color-border-subtle tw-py-2"
          >
            <span class="tw-text-sm tw-text-color-text-secondary">{{ "source" | i18n }}</span>
            <app-category-source-badge [source]="source()"></app-category-source-badge>
          </div>

          @if (source() === categorySource.manual) {
            <button
              type="button"
              (click)="saveCategoryName()"
              class="tw-mt-1 tw-flex tw-h-12 tw-w-full tw-items-center tw-justify-center tw-rounded-[50px] tw-bg-dt-surface-on-action tw-px-6 tw-shadow-elevation-cta-glow"
            >
              <span
                class="tw-whitespace-nowrap tw-text-[20px] tw-font-medium tw-tracking-[0.005em] tw-leading-[135%] tw-text-color-text-on-action sm:tw-text-[18px]"
                >{{ "save" | i18n }}</span
              >
            </button>
          }
        </div>
      </app-widget>
    </div>
  </div>

  @if (source() === categorySource.manual) {
    <div class="tw-px-3 tw-py-4">
      <button
        type="button"
        class="danger tw-flex tw-h-12 tw-w-full tw-items-center tw-justify-center tw-gap-2 tw-rounded-[50px] disabled:tw-cursor-not-allowed disabled:tw-opacity-50"
        [disabled]="isDeleting()"
        (click)="deleteCategory()"
      >
        <icon [name]="'trash-bin'" [currentColor]="'danger'" [size]="4"></icon>
        <span
          class="tw-whitespace-nowrap tw-text-[16px] tw-font-medium tw-tracking-[0.005em] tw-leading-[135%] sm:tw-text-[12px]"
          >{{ "deleteCategory" | i18n }}</span
        >
      </button>
    </div>
  } @else {
    <div
      class="tw-mx-3 tw-mb-4 tw-flex tw-items-start tw-gap-2 tw-rounded-xl tw-bg-color-surface-sunken tw-p-3"
    >
      <icon [name]="'info-circle'" [currentColor]="'color-icon-default'" [size]="4"></icon>
      <span class="tw-text-color-text-secondary">{{ "systemCategoryReadOnlyNote" | i18n }}</span>
    </div>
  }
</app-details-wrapper>
